import { render, staticRenderFns } from "./wrap-form.vue?vue&type=template&id=1ca80506&"
import script from "./wrap-form.vue?vue&type=script&lang=js&"
export * from "./wrap-form.vue?vue&type=script&lang=js&"
import style0 from "./wrap-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports